import { render, staticRenderFns } from "./AddAreaDialog.vue?vue&type=template&id=312de580&scoped=true&"
import script from "./AddAreaDialog.vue?vue&type=script&lang=js&"
export * from "./AddAreaDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddAreaDialog.vue?vue&type=style&index=0&id=312de580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312de580",
  null
  
)

export default component.exports